export enum NotificationEnum {
  ISSUE = 'issue',
  ANNOUNCEMENT = 'announcement',
}
